<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="wp">
            <div class="infow01">
                <div class="infow01-lab">
                    <div class="lab">{{ objTitle[type] }}</div>
                </div>
                <div class="infow01-val">
                    <div class="formw01">
                        <div class="formw01-item s2">
                            <div class="formw01-lab valign-top">标题</div>
                            <div class="formw01-val">
                                <div v-if="type == 'view'">{{ title }}</div>
                                <textarea v-else class="formw01-area s1" v-model="title"></textarea>
                            </div>
                        </div>
                        <div class="formw01-item s2">
                            <div class="formw01-lab valign-top">问题详情</div>
                            <div class="formw01-val">
                                <div v-if="type == 'view'">{{ content }}</div>
                                <textarea v-else class="formw01-area s2" v-model="content"></textarea>
                            </div>
                        </div>
                        <div v-if="type == 'put'" class="formw01-item-ft">
                            <div class="btn s1" @click="$router.back()">取　消</div>
                            <div class="btn s2" @click="putQuestion">提　交</div>
                        </div>
                        <div v-if="type == 'edit'" class="formw01-item-ft">
                            <div class="btn s1" @click="$router.back()">取　消</div>
                            <div class="btn s2" @click="editQuestion">提　交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import http from '@/libs/http.js'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Notify, Toast } from 'vant'

    export default {
        name: "PutQuestion",
        data: function () {
            return {
                objTitle: {
                    'put': '发布问题',
                    'view': '查看问题',
                    'edit': '编辑问题'
                },
                type: this.$route.query.type || 'put',
                question_id: this.$route.query.type || '',
                title: this.$route.query.title || '',
                content: this.$route.query.content || ''
            }
        },
        components: {
            Header, Footer
        },
        mounted () {
        },
        methods: {
            putQuestion: function(){
                var _this = this;
                if (!_this.title.length > 0) {
                    Notify('请输入问题标题');
                } else if (!_this.content.length > 0) {
                    Notify('请输入所要提出的问题详情');
                } else {
                    let param = new FormData();
                    param.append('title', _this.title),
                    param.append('content', _this.content)
                    http.post(_this.sysUrl.putQuestion, param).then(function(response){
                        if (response.status == 1) {
                            Toast(response.msg);
                            setTimeout(function(){
                                _this.$router.replace({path:'/ProblemList'})
                            }, 2000)
                        } else {
                            Toast(response.msg);
                        }
                    })
                }
            },
            editQuestion: function(){
                var _this = this;
                if (!_this.title.length > 0) {
                    Notify('请输入问题标题');
                } else if (!_this.content.length > 0) {
                    Notify('请输入所要提出的问题详情');
                } else {
                    http.post(_this.sysUrl.editQuestion, {
                        question_id: _this.question_id,
                        title: _this.title,
                        content: _this.content
                    }).then(function(response){
                        if (response.status == 1) {
                            Toast(response.msg);
                        } else {
                            Toast(response.msg);
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .infow01 {padding: .5rem 0;}
    .formw01-area.s1 {height: 1.5rem;}
    .formw01-area.s2 {height: 3rem;}
</style>